import React from 'react';
import SortByDropdown from '../../components/SortByDropdown';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

class PaginationContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            paginationViewModel,
            onCurrentSortByChange,
        } = this.props;
        const firstProductNumber = paginationViewModel.CurrentItemsOnPage === 0 
            ? 0
            : paginationViewModel.CurrentPageIndex * paginationViewModel.CurrentItemsPerPage + 1;
        const lastProductNumber = firstProductNumber === 0 
            ? 0
            : firstProductNumber + paginationViewModel.CurrentItemsOnPage - 1;
        return (
            <div className="category-list-pagination-wrapper">
                
                <div className="pagination-dropdown-wrapper d-flex align-items-center justify-content-end mb-3 mb-md-6 flex-wrap">
                        <label className="text-sm mb-md-0 mr-0 mr-md-3">
                            {translateResourceString("/SearchApp/Results")} {firstProductNumber} - {lastProductNumber} {translateResourceString("/SearchApp/Of")} {paginationViewModel.ResultsTotal}
                        </label>
                        <SortByDropdown {...paginationViewModel} onCurrentSortByChange={onCurrentSortByChange} />
                    </div>
                
            </div>
        );
    }
};

PaginationContainer.propTypes = {
    paginationViewModel: PropTypes.shape({
        ResultsTotal: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        CurrentPageIndex: PropTypes.number,
        CurrentSortBy: PropTypes.string,
        CurrentItemsOnPage: PropTypes.number
    }),
    onCurrentItemsPerPageChange: PropTypes.func,
    onCurrentSortByChange: PropTypes.func,
    onCurrentPageIndexChange: PropTypes.func,
    onShowMobileFacetsChange: PropTypes.func.isRequired
};

export default PaginationContainer;